import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AuthActions } from '../../../auth/store/actions/index';
import { SiteContextActions } from '../../../site-context/store/actions/index';
import { CmsRoute } from '../../models/cms-route';
import { RoutingActions } from '../actions/index';

@Injectable()
export class RouterEffects {
  navigate$: Observable<any> = createEffect(
    () => this.actions$.pipe(
      ofType(RoutingActions.ROUTER_GO),
      map((action: RoutingActions.RouteGoAction) => action.payload),
      tap(({ path, query: queryParams, extras }) => {
        this.router.navigate(path, { queryParams, ...extras });
      })
    ),
    { dispatch: false }
  );

  navigateBuUrl$: Observable<any>= createEffect(
    () => this.actions$.pipe(
      ofType(RoutingActions.ROUTER_GO_BY_URL),
      map((action: RoutingActions.RouteGoAction) => action.payload),
      tap((url) => {

        // @ts-ignore
        this.router.navigateByUrl(url);
      })
    ),
    { dispatch: false }
  );


  clearCmsRoutes$: Observable<Action> = createEffect(
    () => this.actions$.pipe(
      ofType(
        SiteContextActions.LANGUAGE_CHANGE,
        AuthActions.LOGOUT,
        AuthActions.LOGIN
      ),
      tap(() => {
        const filteredConfig = this.router.config.filter(
          (route: CmsRoute) => !(route.data && route.data.cxCmsRouteContext)
        );
        if (filteredConfig.length !== this.router.config.length) {
          this.router.resetConfig(filteredConfig);
        }
      })
    ),
    { dispatch: false }
  );


  navigateBack$: Observable<Action> = createEffect(
    () => this.actions$.pipe(
      ofType(RoutingActions.ROUTER_BACK),
      tap(() => this.location.back())
    ),
    { dispatch: false }
  );


  navigateForward$: Observable<Action> = createEffect(
    () => this.actions$.pipe(
      ofType(RoutingActions.ROUTER_FORWARD),
      tap(() => this.location.forward())
    ),
    { dispatch: false }
  );


  constructor(
    private actions$: Actions,
    private router: Router,
    private location: Location
  ) {}
}
